import React from 'react';

function NotFoundPage() {
  return (
    <div>
      <h1>404</h1>
      <p>페이지를 찾을 수 없습니다.</p>
    </div>
  );
}

export default NotFoundPage;

